import axios from "axios";
import * as actionType from "../../../constant/actionType";

export const GenerateWorkerInductionReport = (apiData) => async (dispatch) => {
  try {
    const response = await axios({
      method: "get", // Change GET to POST
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        "Content-Type": "application/json",
      },
      url: `${actionType.environment_url}/api/admin/worker/GenerateWorkerInductionReport`,
      params: {
        ...apiData,
        client_org_ids: JSON.stringify(apiData.client_org_ids),
        provider_org_ids: JSON.stringify(apiData?.provider_org_ids),
        com_ind_ids: JSON.stringify(
          apiData.com_ind_ids?.map((item) => item?.induction_id)
        ),
        worker_ids: JSON.stringify(apiData?.worker_ids),
        site_ind_ids: JSON.stringify(
          apiData.site_ind_ids?.map((item) => item?.induction_id)
        ),
      },
    });

    return response.data;
  } catch (error) {
    return error.message;
  }
};
